import React from 'react';
import { Box, Heading, HStack, VStack } from '@chakra-ui/react';
import Breadcrumbs from './Breadcrumbs';
import { spacing, headingStyles } from '../../theme/designSystem';

/**
 * PageHeader Component
 *
 * Provides consistent page header layout with breadcrumbs, title, and actions.
 *
 * @param {string} title - Page title
 * @param {Array} breadcrumbs - Breadcrumb items array
 * @param {ReactNode} actions - Action buttons (typically HStack of buttons)
 * @param {ReactNode} subtitle - Optional subtitle or description
 */
function PageHeader({ title, breadcrumbs, actions, subtitle }) {
  return (
    <Box mb={spacing.section}>
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
      <HStack justify="space-between" align="flex-start" mt={spacing.item}>
        <VStack align="start" spacing={spacing.compact}>
          <Heading {...headingStyles.page}>{title}</Heading>
          {subtitle}
        </VStack>
        {actions && <HStack spacing={spacing.item}>{actions}</HStack>}
      </HStack>
    </Box>
  );
}

export default PageHeader;
